export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-F1-F4.f6a6d6fd.jpg";